const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export const normalizePathname = (value: string): string => {
  let pathname = value.trim();

  if (ABSOLUTE_URL_REGEX.test(pathname)) {
    pathname = new URL(pathname).pathname;
  }

  pathname = pathname.split("?").shift() ?? "";
  pathname = pathname.split("#").shift() ?? "";

  if (!pathname.startsWith("/")) {
    pathname = `/${pathname}`;
  }

  if (pathname !== "/") {
    pathname = pathname.replace(/\/+$/, "");
  }

  return pathname;
};

export const matchPathname = (value: string): boolean => {
  if (typeof window === "undefined" || !value) {
    return false;
  }

  return (
    normalizePathname(value) === normalizePathname(window.location.pathname)
  );
};
